import { Injectable, Injector } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { LoadingService } from './loading.service';
// import { Observable } from 'fabric';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private tenantKey: string = '';
  private tenantId: string | null = null;
  private tenantType: string | null = null;
  // public tenantType$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private injector: Injector) {
    this.tenantKey = this.extractTenantKeyFromPath();
  }

  ngOnInit() {
    const apiService = this.injector.get(ApiService);
    apiService.getData(`getTenantByKey/${this.tenantKey}`).subscribe({
      next: (data: any) => {

        this.tenantId = data?.tenantId;
        this.tenantType = data?.tenantType;
        // this.tenantType$.next(this.tenantType);
      },
      error: (err: any) => {
        console.error('Failed to resolve tenant ID:', err);
        this.tenantId = null; // Fallback if API call fails
      }
    });
  }

  initializeTenant(): Promise<boolean> {
    const tokenKey = 'resolvedTenant_' + this.tenantKey;
    const cached = sessionStorage.getItem(tokenKey);

    if (cached) {
      const data = JSON.parse(cached);
      this.tenantId = data?.tenantId || null;
      this.tenantType = data?.tenantType || null;
      return Promise.resolve(!!this.tenantId);
    }

    // Lazily inject services to avoid circular dependency
    const apiService = this.injector.get(ApiService);
    const loadingService = this.injector.get(LoadingService);

    loadingService.show();

    return firstValueFrom(
      apiService.getData(`Tenant/getTenantByKey/${this.tenantKey}`)
    )
      .then((data: any) => {
        this.tenantId = data?.tenantId || null;
        this.tenantType = data?.tenantType || null;

        // Cache it in sessionStorage
        sessionStorage.setItem(tokenKey, JSON.stringify({
          tenantId: this.tenantId,
          tenantKey: this.tenantKey,
          tenantType: this.tenantType
        }));

        loadingService.hide();

        return !!this.tenantId;
      })
      .catch((err: any) => {
        console.error('Tenant validation failed:', err);
        this.tenantId = null;
        loadingService.hide();
        return false;
      });
  }



  /**
   * Extracts the tenant key from the first path segment of the URL.
   */
  private extractTenantKeyFromPath(): string {
    const pathSegments = window.location.pathname.split('/').filter(Boolean); // removes empty parts
    return pathSegments.length > 0 ? pathSegments[0] : '';
  }

  /**
   * Gets the tenant key (like 'appOne').
   */
  getTenantKey(): string {
    return this.tenantKey;
  }

  /**
   * Gets the resolved tenant ID (like 'abc-123').
   */
  getTenantId(): string | null {
    return this.tenantId;
  }

  getTenantType(): string | null {
    return this.tenantType;
  }

  /**
   * Whether a valid tenant ID was resolved.
   */
  isValidTenant(): boolean {
    return this.tenantId !== null;
  }

  /**
   * Optional: Allows dynamic mapping from backend result.
   */
  setTenantIdFromApi(tenantId: string): void {
    this.tenantId = tenantId;
  }

  /**
   * Optional: Returns a full routerLink path including tenant key.
   */
  getTenantPrefixedPath(relativePath: string): string[] {
    return ['/', this.tenantKey, ...relativePath.split('/')];
  }
}
